import { createMockListResponse as e } from "../../../helpers/CreateMockListResponse.js";
//#region src/resources/batch-answer/datasets/BatchAnswerDatasets.mocks.ts
var t = (e = 0, t = 200) => ({
	id: `dataset-${e}`,
	name: `Dataset ${e}`,
	queries: Array.from({ length: t }, (e, t) => ({ text: `Sample query text ${t}` }))
}), n = e(t);
//#endregion
export { t as createMockBatchAnswerDataset, n as createMockBatchAnswerDatasetListResponse };

//# sourceMappingURL=BatchAnswerDatasets.mocks.js.map